const NAMESPACE = "addAttachmentDialog";

const KEYS = {
    addAttachmentDialogSelectLabel: "addAttachmentDialogSelectLabel",
    addAttachmentDialogSelectDefaultText: "addAttachmentDialogSelectDefaultText",
    noteLabel: "noteLabel",
    unsupportedExtensionsWarningText: "unsupportedExtensionsWarningText",
    largeFileWarningText: "largeFileWarningText"
};

const MESSAGES = {
    [KEYS.addAttachmentDialogSelectLabel]: {
        value: "Pick the attachment:",
        comment:
            "Label for the selector which allows the user to select the attachment they want to add to the communication"
    },
    [KEYS.addAttachmentDialogSelectDefaultText]: {
        value: "Select an attachment...",
        comment:
            "Default text for the selector that allows the user to select the attachment they want to add to the communication"
    },
    [KEYS.noteLabel]: { value: "Note:", comment: "Label for an informative note" },
    [KEYS.unsupportedExtensionsWarningText]: {
        value: "This attachment definition has been configured to accept one or more file types that cannot be included as attachments on PowerClerk communications. These file types are:",
        comment:
            "Note explaining that the selected attachment definition allows certain types of files which cannot be included in communications"
    },
    [KEYS.largeFileWarningText]: {
        value: "This attachment definition accepts large files. Communications that are too large, including the combined size of their attachments, may fail to send.",
        comment:
            "Note explaining that the selected attachment definition allows files which could cause the communication to fail to send"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
